<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>项目</el-breadcrumb-item>
        <el-breadcrumb-item>调剂系统</el-breadcrumb-item>
        <el-breadcrumb-item>信息更新</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">信息更新</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="createDialog = true">创建</el-button>
          <div style="marginRight:10px;"
               class="btBox">
            <input @change="upload"
                   type="file"
                   name="photoImg"
                   id="getFile"
                   style="display:none;"
                   class="upload-input" />
            <label for="getFile"
                   class="fileStyle">导入</label>

          </div>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="年份">
          <el-select v-model="query.year"
                     @change="fetchList"
                     clearable
                     placeholder="请选择">
            <el-option v-for="(item, index) in filter.years"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="院校：">
          <el-select v-model="query.college_code"
                     filterable
                     placeholder="请选择"
                     @change="collegeChange"
                     style="width:100%;"
                     clearable>
            <el-option v-for="(item, index) in $store.state.collegeList"
                       :key="index"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业：">
          <el-select v-model="query.major_code"
                     filterable
                     placeholder="请选择"
                     @change="majorChange"
                     style="width:100%;"
                     clearable>
            <el-option v-for="(item, index) in majorList"
                       :key="index"
                       :label="item.name"
                       :value="item.code">
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学院：">
          <el-select v-model="query.academy_code"
                     filterable
                     placeholder="请选择"
                     @change="fetchList"
                     style="width:100%;"
                     clearable>
            <el-option v-for="(item, index) in academylist"
                       :key="index"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上下线状态">
          <el-select v-model="query._deletes"
                     placeholder="请选择"
                     @change="fetchList(true)"
                     clearable>
            <el-option v-for="item in filter.delete_types"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="创建人">
          <el-select v-model="query.creators"
                     placeholder="请选择"
                     @change="fetchList(true)"
                     clearable
                     multiple>
            <el-option v-for="item in $store.state.adminList"
                       :key="item.id"
                       :label="item.nickname"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title"></h3>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="ID"
                           width="80"
                           fixed="left"
                           align="center"></el-table-column>

          <el-table-column label="年份"
                           width="100"
                           align="center">
            <template slot-scope="scope">
              {{ scope.row.year }}年考研
            </template>
          </el-table-column>
          <el-table-column prop="college_name"
                           label="院校名称"
                           align="center"
                           show-overflow-tooltip
                           width="120px">
          </el-table-column>
          <el-table-column label="专业名称"
                           align="center"
                           width="200px"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              [{{ scope.row.major_code }}]{{ scope.row.major_name }}
            </template>
          </el-table-column>
          <el-table-column label="学院名称"
                           width="200px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              ({{ scope.row.academy_code }}){{ scope.row.academy_name }}
            </template>
          </el-table-column>
          <el-table-column label="方向名称"
                           width="200px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              ({{ scope.row.direction_code }}){{ scope.row.direction_name }}
            </template>
          </el-table-column>
          <el-table-column label="学习方式"
                           width="90px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.enrol_type == 2 ? "非全日制" : "全日制"}}
            </template>
          </el-table-column>
          <el-table-column prop="plan_last_count"
                           label="调剂余额"
                           width="90px"
                           align="center"
                           show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="上下线状态"
                           width="90px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag :type="scope.row._delete==0?'success':'info'">
                {{scope.row._delete==0?'上线':'下线'}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="搜集人"
                           width="90px"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.creator?scope.row.creator.nickname:''}}
            </template>
          </el-table-column>
          <el-table-column label="更新日期"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.update_time).format("YYYY.MM.DD HH:mm") }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建日期"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.create_time).format("YYYY.MM.DD HH:mm") }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right"
                           label="操作"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handleToEdit(scope.row)">编辑</el-link>
              <el-link type="danger"
                       :underline="false"
                       @click="handleToRemove(scope.row.id)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <div></div>
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <InformationCreate :visible="createDialog"
                       @close="createDialog=false"
                       @submit="fetchList"></InformationCreate>
    <InformationEdit :visible="editDialog"
                     @close="editDialog=false"
                     :id="editId"
                     @submit="fetchList"></InformationEdit>
    <el-dialog title="导入结果"
               :visible.sync="importResultDialog"
               width="70%"
               :close-on-click-modal="false">
      <div style="margin-bottom: 20px;">{{message}}</div>
      <el-table :data="arr_fail_info"
                border
                style="width: 100%"
                max-height="400"
                v-if="arr_fail_info.length>0">
        <el-table-column prop="row_no"
                         label="行号"
                         width="80"
                         align="center">
        </el-table-column>
        <el-table-column prop="comb_info"
                         label="综合信息"
                         min-width="300"
                         show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="error_msg"
                         label="错误原因"
                         min-width="300"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="error-msg">{{ scope.row.error_msg }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer"
            class="dialog-footer"
            style="display: flex; justify-content: flex-end;">
        <el-button type="primary"
                   @click="handleExport"
                   v-if="exportEnabled&&exportUrl"
                   style="margin-right: 10px;">
          {{ exportButtonText }}
        </el-button>
        <el-button type="primary"
                   @click="closeImportResult">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Loading } from 'element-ui'
import InformationCreate from '@/components/dialog/adjust/InformationCreate.vue'
import InformationEdit from '@/components/dialog/adjust/InformationEdit.vue'
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
} from '@/api/common'
import { adjustAdminlist, deleteAdjustAdmin, byFileImport } from '@/api/adjust'

export default {
  components: {
    InformationCreate,
    InformationEdit,
  },
  data() {
    return {
      message: '',
      importResultDialog: false,
      arr_fail_info: [],
      exportUrl: '',
      exportEnabled: true,
      exportButtonText: '导出',
      timer: null,
      countdown: 30,
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      chooseList: [],
      createDialog: false,
      editDialog: false,
      editId: null,
      filter: {
        years: [
          { label: '2027年考研', value: 2027 },
          { label: '2026年考研', value: 2026 },
          { label: '2025年考研', value: 2025 },
          { label: '2024年考研', value: 2024 },
          { label: '2023年考研', value: 2023 },
        ],
        enrol_types: [
          { label: '全日制', value: 1 },
          { label: '非全日制', value: 2 },
        ],
        delete_types: [
          { label: '上线', value: 0 },
          { label: '下线', value: 2 },
        ],
      },
      majorList: [],
      academylist: [],
    }
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.start_create_time = this.$moment(value[0]).valueOf()
        this.query.end_create_time = this.$moment(value[1]).valueOf()
      } else {
        this.query.start_create_time = ''
        this.query.end_create_time = ''
        this.fetchList(true)
      }
    },
  },
  created() {
    this.$store.dispatch('getAllColleges')
    this.$store.dispatch('getAdminList')

    this.fetchList()
  },
  methods: {
    upload(e) {
      const file = e.target.files[0]

      if (file) {
        const loading = Loading.service({
          fullscreen: false,
          lock: true,
          text: '正在导入数据，请稍候...',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        const fileName = file.name
        const fileExt = fileName
          .substring(fileName.lastIndexOf('.') + 1)
          .toLowerCase()
        if (fileExt !== 'xlsx' && fileExt !== 'xls' && fileExt !== 'csv') {
          this.$message.error('请上传Excel文件（.xlsx, .xls, .csv格式）')
          return
        }
        let formData = new FormData()
        formData.append('file', file)
        formData.append('file_exam_total_name', file.name)

        byFileImport(formData).then((res) => {
          loading.close()
          console.log('res', res)

          const {
            total_count,
            success_count,
            fail_count,
            arr_fail_info = [],
            fail_export_url,
          } = res
          this.message = `导入完成\n总条数：${total_count}\n成功：${success_count}\n失败：${fail_count}`
          if (fail_count > 0 && arr_fail_info.length > 0) {
            //导入失败
            this.arr_fail_info = arr_fail_info
            if (fail_export_url) {
              this.exportUrl = fail_export_url
              this.startCountdown()
            }
          }
          this.importResultDialog = true
        })
      }
    },
    closeImportResult() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.importResultDialog = false
      this.fetchList()
    },
    // 开始倒计时
    startCountdown() {
      this.countdown = 30
      this.exportEnabled = true
      this.exportButtonText = `导出(${this.countdown}s)`

      // 清除之前的定时器
      if (this.timer) {
        clearInterval(this.timer)
      }

      this.timer = setInterval(() => {
        this.countdown--

        if (this.countdown > 0) {
          this.exportButtonText = `导出(${this.countdown}s)`
        } else if (this.countdown == 0) {
          this.exportEnabled = false
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },

    // 处理导出
    handleExport() {
      // window.open(this.exportUrl, '_blank')
      window.location.href = this.exportUrl
    },
    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)
      if (params.creators) {
        this.position = params.creators = params.creators.join(',')
      }
      adjustAdminlist(params).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },

    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.creators && this.query.creators.length) {
        this.query.creators = this.query.creators.split(',').map((v) => {
          return Number(v)
        })
      }
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query)
      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      )
      if (params.creators) {
        params.creators = params.creators.filter((v) => v).join(',')
      }
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        })
    },
    handleToEdit(row) {
      this.editId = row.id
      this.editDialog = true
    },
    collegeChange(e) {
      if (e) {
        this.fetchMajor(e)
      }
      setTimeout(() => {
        this.fetchList(true)
      }, 500)
    },
    fetchMajor(college_code) {
      collegeMajorList({ college_code, isPaging: 0 }).then((res) => {
        this.majorList = res.list
      })
    },
    majorChange(e) {
      if (e) {
        this.fetchAcademy(this.query.college_code, e)
      }
      setTimeout(() => {
        this.fetchList(true)
      }, 500)
    },
    fetchAcademy(college_code, major_code) {
      academyList({ college_code, major_code, isPaging: 0 }).then((res) => {
        this.academylist = res.list
      })
    },
    handleToRemove(id) {
      this.$confirm('确定要删除此条信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteAdjustAdmin({ id }).then((res) => {
          this.fetchList(true)
        })
      })
    },
  },
}
</script>
  
  <style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
      .fileStyle {
        position: relative;
        margin-left: 5px;
        border-radius: 2px;
        padding: 7px 15px;
        color: #ffff;
        background: #409eff;
      }
      ::v-deep .el-upload-list {
        display: none !important;
      }
      .btBox {
        position: relative;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
.el-tag {
  margin: 0px 5px;
}
.tag-wrap {
  text-align: left;
}
</style>
  